module.exports = __webpack_public_path__ + "img/95ne.7f676287.svg";